const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

if (!configuredApiBaseUrl) {
  throw new Error('缺少环境变量 REACT_APP_API_BASE_URL');
}

// 支付、身份认证等 Laravel 接口统一使用同一个 API 根地址。
export const API_BASE_URL = configuredApiBaseUrl;
